<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M4 7H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M4 17H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
</svg>
